import Fade from 'react-reveal/Fade';
import Tada from 'react-reveal/Tada';
export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <Tada duration={2000}>
            <img src="img/about.jpg" className="img-responsive" alt="" />{" "}
            </Tada>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <Fade bottom distance="10%" duration={1500}>
              <h2>Tentang Kami</h2>
              </Fade>
              {/* <p>{props.data ? props.data.paragraph : "loading..."}</p> */}
              <Fade left distance="10%" duration={1500}>
              <h3>Visi</h3>
              <div className="list-style">
              <ul>
                <li>Sehat</li>
                <li>Berakhlak Mulia</li>
                <li>Cerdas Dalam Ilmu</li>
                </ul>      
              </div>
              </Fade>
              <Fade right distance="10%" duration={1500}>
              <h3>Misi</h3>
              <div className="list-style">
              <ul>
                <li>Menyiapkan Lingkungan Madrasah yang Islami dan Sehat</li>
                <li>Menenamkan Kesadaran Akan Pentingnya Hidup Sehat Bagi Warga Madrasah</li>
                <li>Memotivasi Siswa Untuk Menggali Potensi Diri Dalam Meraih Prestasi</li>
                </ul>      
              </div>
              </Fade>
              {/* <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
